module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-221.3bb4109.woff2";